<template>
  <el-dialog
    title="选择属性值"
    :visible.sync="attributeValuesVisiable"
    class="small-dialog"
    :close-on-click-modal="false"
    v-dialogDrag
    @open="openDialog"
    :before-close="closeDialog"
  >
    <div>
      <el-input
        v-model="keywords"
        class="w-200px mr-10px"
        clearable
        placeholder="请输入"
      ></el-input>
      <el-button type="primary" @click="searchTableData">{{ $t('search') }}</el-button>
      <el-button @click="reset">{{ $t('reset') }}</el-button>
    </div>
    <el-table
      :data="tableData"
      v-loading="tableLoading"
      border
      class="mt-20px"
      height="calc(100% - 104px)"
    >
      <el-table-column type="index" label="序号" width="55"></el-table-column>
      <el-table-column prop="value" label="属性值" show-overflow-tooltip></el-table-column>
      <el-table-column label="操作" fixed="right" width="100">
        <template slot-scope="scope">
          <el-button size="mini" @click="submit(scope.row)">确定</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="mt-20px float-right">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="page.pageNo"
        :page-sizes="$pageSizeAll"
        :page-size="page.pageSize"
        :pager-count="5"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.total"
      ></el-pagination>
    </div>
  </el-dialog>
</template>

<script>
import ModelParsingTaskService from '@/services/ModelParsingTaskService'

export default {
  props: ['attributeValuesVisiable', 'classId', 'classAttributeId', 'attributeCode'],
  data() {
    return {
      keywords: '',
      tableData: [],
      tableLoading: false,
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
    }
  },
  methods: {
    openDialog() {
      this.searchTableData()
    },
    closeDialog() {
      this.$emit('closeAttributeDialog')
    },
    async searchTableData() {
      this.tableLoading = true
      const res = await ModelParsingTaskService.getAttributeValuesList({
        maxResultCount: this.page.pageSize,
        skipCount: (this.page.pageNo - 1) * this.page.pageSize,
        classId: this.classId,
        classAttributeId: this.classAttributeId,
        filter: this.keywords,
      })
      this.tableLoading = false
      if (res && res.code === 0 && res.data) {
        this.tableData = _.map(res.data, (item) => {
          item.value = item[this.attributeCode]
          return item
        })
        this.page.total = res.totalCount
      } else {
        this.tableData = []
        this.page.total = 0
      }
    },
    reset() {
      this.keywords = ''
      this.searchTableData()
    },
    handleSizeChange(pageSize) {
      this.page.pageSize = pageSize
      this.searchTableData()
    },
    handleCurrentChange(pageNo) {
      this.page.pageNo = pageNo
      this.searchTableData()
    },
    submit(row) {
      this.$emit('updateAttributeValue', row)
      this.closeDialog()
    },
  },
}
</script>
